import React from 'react'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './PdfPreview.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close, File } from 'blaze-ui/icons'

interface PdfPreviewProps {
  file: File
  onRemove: () => void
}

export const PdfPreview: React.FC<PdfPreviewProps> = ({ file, onRemove }) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.iconContainer}>
        <File />
      </div>
      <div className={Styles.info}>
        <Text>{file.name}</Text>
      </div>
      <IconButton size="sm" variant="tertiary" onPress={onRemove} icon={Close} aria-label="Remove PDF" />
    </div>
  )
}
